// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5d31bdff","126":"331eedf6","151":"e92deba3","225":"4a82b66e","243":"339b0ca1","415":"836fdc92","463":"a57a773f","482":"b0e78eb5","649":"0b50801c","684":"fc025577"}[chunkId] + ".chunk.js";
};